(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hs-van-promotion"] && !Shopify.designMode) return;
  try {
    

(()=>{
class HsVanPromotion extends HTMLElement {
connectedCallback(){
if(this.initialized)return;this.initialized=true;const root=this;
const van=root.querySelector('.hs-van');
const lane=root.querySelector('.hs-lane');
const replay=root.querySelector('[data-replay]');
const status=root.querySelector('[data-status]');
const special=root.querySelector('.hs-special');
const call=root.querySelector('.hs-call');
const phone=root.querySelector('.hs-phone');
const pause=root.querySelector('[data-pause]');
const coupon=root.querySelector('.hs-coupon');
const finalOffers=root.querySelector('.hs-final-offers');
const finalSavings=root.querySelector('.hs-final-savings');
const promo=root.querySelector('.hs-promo');
let animations=[];
let phoneTimer;
let paused=false;
let reduced=false;
const burstFrames=[{visibility:'hidden',opacity:0,transform:'scale(.2) rotate(-12deg)',offset:0},{visibility:'visible',opacity:1,transform:'scale(1.08) rotate(2deg)',offset:.08},{visibility:'visible',opacity:1,transform:'scale(1) rotate(0deg)',offset:.15},{visibility:'visible',opacity:1,transform:'scale(1) rotate(0deg)',offset:.88},{visibility:'hidden',opacity:0,transform:'scale(.4) rotate(10deg)',offset:1}];
function drive(manual=false){
 animations.forEach(animation=>animation.cancel());
 animations=[];
 clearTimeout(phoneTimer);
 paused=false;
 pause.textContent=root.dataset.pause;
 phone.style.visibility='hidden';
 phone.style.opacity='0';
 phone.style.right='20px';
 reduced=matchMedia('(prefers-reduced-motion: reduce)').matches;
 const centeredRight=`calc(50% - ${phone.getBoundingClientRect().width/2}px)`;
 finalOffers.style.visibility='hidden';
 finalOffers.style.opacity='0';
 if(reduced&&!manual){phone.style.right=centeredRight;phone.style.visibility='visible';phone.style.opacity='1';finalOffers.style.visibility='visible';finalOffers.style.opacity='1';status.textContent=root.dataset.reduced;return;}
 const distance=lane.getBoundingClientRect().width+van.getBoundingClientRect().width;
 const laneLeft=lane.getBoundingClientRect().left;
 const clearedAt=box=>8000*(distance-(box.getBoundingClientRect().left-laneLeft-18))/distance;
 const specialDelay=clearedAt(special);
 const callDelay=clearedAt(call);
 const disappearAt=Math.max(specialDelay,callDelay)+2300;
 const phoneDelay=disappearAt+200;
 animations.push(van.animate([{transform:'translateX(0)'},{transform:`translateX(-${distance}px)`}],{duration:8000,easing:'linear',fill:'none'}));
 animations.push(special.animate(burstFrames,{duration:disappearAt-specialDelay,delay:specialDelay,fill:'both'}));
 animations.push(call.animate(burstFrames,{duration:disappearAt-callDelay,delay:callDelay,fill:'both'}));
 const reveal=phone.animate([{opacity:0,transform:'scale(.7)'},{opacity:1,transform:'scale(1)'}],{duration:350,delay:phoneDelay,fill:'forwards'});
 animations.push(reveal);
 animations.push(phone.animate([{right:'20px'},{right:centeredRight}],{duration:1400,delay:phoneDelay+700,easing:'ease-in-out',fill:'forwards'}));
 animations.push(finalOffers.animate([{visibility:'hidden',opacity:0,transform:'scale(.8)'},{visibility:'visible',opacity:1,transform:'scale(1)'}],{duration:400,delay:phoneDelay+3100,easing:'ease-out',fill:'forwards'}));
 phone.style.visibility='visible';
 if(!reduced)animations.push(phone.animate([{filter:'brightness(1)',transform:'scale(1)'},{filter:'brightness(1.14)',transform:'scale(1.035)'},{filter:'brightness(1)',transform:'scale(1)'}],{duration:1600,delay:phoneDelay+350,iterations:Infinity,fill:'none'}));
 phoneTimer=setTimeout(()=>{status.textContent=root.dataset.callstatus;},phoneDelay+350);
 status.textContent=root.dataset.offerstatus;
}
function showCoupon(source){
 const bounds=source.getBoundingClientRect();
 const parent=promo.getBoundingClientRect();
 coupon.style.right='auto';
 coupon.style.bottom='auto';
 coupon.style.left=`${bounds.left-parent.left}px`;
 coupon.style.top=`${bounds.top-parent.top}px`;
 coupon.style.width=`${bounds.width}px`;
 coupon.style.height=`${bounds.height}px`;
 const frames=reduced?[{opacity:1},{opacity:1,offset:.8},{opacity:0}]:[{opacity:0,transform:'scale(.15) rotate(-18deg)'},{opacity:1,transform:'scale(1.1) rotate(3deg)',offset:.15},{opacity:1,transform:'scale(1) rotate(0deg)',offset:.75},{opacity:0,transform:'scale(1.45) rotate(12deg)'}];
 const animation=coupon.animate(frames,{duration:2600,easing:'ease-out',fill:'none'});
 animations.push(animation);
 if(paused)animation.pause();
 status.textContent=root.dataset.coupon;
}
special.addEventListener('click',()=>showCoupon(special));
finalSavings.addEventListener('click',()=>showCoupon(finalSavings));
pause.addEventListener('click',()=>{paused=!paused;animations.forEach(animation=>paused?animation.pause():animation.play());pause.textContent=paused?root.dataset.resume:root.dataset.pause;});
replay.addEventListener('click',()=>drive(true));
const start=()=>{const observer=new IntersectionObserver(entries=>{if(entries.some(entry=>entry.isIntersecting)){observer.disconnect();drive();}},{threshold:.25});observer.observe(root);root.observer=observer;};
if(van.complete)start();else van.addEventListener('load',start,{once:true});
this.cleanup=()=>{animations.forEach(a=>a.cancel());clearTimeout(phoneTimer);this.observer?.disconnect();};
}
disconnectedCallback(){this.cleanup?.();}
}
if(!customElements.get('hs-van-promotion'))customElements.define('hs-van-promotion',HsVanPromotion);
})();


  } catch(e) { console.error(e); }
})();
})();
